import { useEffect } from 'react'
import { EscManager } from '../singletons/EscManager'
import { useEvent } from './useEvent'

export const useCallbackOnEsc = (callback) => {
    const eventCallback = useEvent(callback)

    useEffect(() => {
        EscManager.getInstance().addCallback(eventCallback)

        return () => {
            EscManager.getInstance().removeCallback(eventCallback)
        }
    }, [])
}



// WEBPACK FOOTER //
// ./hooks/useCallbackOnEsc.js